<div class="step-layout !mx-auto !flex !w-full !flex-col !gap-8">
    <header class="!flex !flex-col !gap-2">
        <p class="!mb-0 !text-xs !font-bold !uppercase !tracking-[0.08em] !text-primary">
            Passo 2 di 8
        </p>
        <h2 class="!mb-0 !text-[clamp(1.75rem,3vw,2.25rem)] !font-extrabold !leading-tight !text-strong">
            Dati del <span class="gradient-text">rappresentante</span>
        </h2>
        <p class="!mb-0 !max-w-xl !text-base !leading-relaxed !text-subtle">
            Inserisci i dati anagrafici del legale rappresentante e carica i documenti richiesti.
        </p>
    </header>

    <form #legalDataStep1="ngForm" class="!flex !flex-col !gap-7" (ngSubmit)="tryContinue(legalDataStep1)">
        <section class="!rounded-2xl !border !border-border !bg-white !p-6 md:!p-8" aria-labelledby="anagrafica-title">
            <div class="!mb-5 !border-b !border-slate-100 !pb-3">
                <h3 id="anagrafica-title" class="!mb-1 !text-base !font-bold !text-strong">Anagrafica</h3>
                <p class="!mb-0 !text-sm !leading-snug !text-subtle">
                    Nome, cognome e identificativi come risultano dai documenti.
                </p>
            </div>

            <div class="!grid !grid-cols-1 !gap-x-5 !gap-y-5 md:!grid-cols-2">
                <div class="!min-w-0">
                    <label for="company-legal-first-name" class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">Nome</label>
                    <input required type="text" class="form-control !min-h-11 !rounded-xl !border-slate-200 focus:!border-primary focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                           id="company-legal-first-name"
                           (ngModelChange)="persistForm()" [(ngModel)]="company.legalFirstName"
                           name="legalFirstName" #legalFirstName="ngModel"
                           autocomplete="given-name"
                           [class.is-invalid]="legalFirstName.invalid && (legalFirstName.dirty || legalFirstName.touched || submitted)"/>
                    <p class="!mb-0 !mt-1.5 !text-sm !text-red-600"
                       *ngIf="legalFirstName.invalid && (legalFirstName.dirty || legalFirstName.touched || submitted)">
                        Il nome è obbligatorio.
                    </p>
                </div>

                <div class="!min-w-0">
                    <label for="company-legal-last-name" class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">Cognome</label>
                    <input type="text" class="form-control !min-h-11 !rounded-xl !border-slate-200 focus:!border-primary focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                           id="company-legal-last-name"
                           (ngModelChange)="persistForm()" [(ngModel)]="company.legalLastName"
                           name="legalLastName" required
                           #legalLastName="ngModel"
                           autocomplete="family-name"
                           [class.is-invalid]="legalLastName.invalid && (legalLastName.dirty || legalLastName.touched || submitted)">
                    <p class="!mb-0 !mt-1.5 !text-sm !text-red-600"
                       *ngIf="legalLastName.invalid && (legalLastName.dirty || legalLastName.touched || submitted)">
                        Il cognome è obbligatorio.
                    </p>
                </div>

                <div class="!min-w-0">
                    <label for="company-legal-fiscal-code" class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">Codice fiscale</label>
                    <input type="text" class="form-control text-uppercase !min-h-11 !rounded-xl !border-slate-200 focus:!border-primary focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                           id="company-legal-fiscal-code"
                           [(ngModel)]="company.legalFiscalCode" name="legalFiscalCode"
                           required minlength="16" maxlength="16" pattern="[a-zA-Z0-9]{16}"
                           #legalFiscalCode="ngModel"
                           autocomplete="off"
                           spellcheck="false"
                           (ngModelChange)="normalizeFiscalCode()"
                           [class.is-invalid]="legalFiscalCode.invalid && (legalFiscalCode.dirty || legalFiscalCode.touched || submitted)">
                    <div class="!mt-1.5 !flex !justify-between !gap-3">
                        <span class="!text-xs !leading-snug !text-slate-400">16 caratteri alfanumerici, senza spazi.</span>
                        <span class="!text-xs !font-semibold !tabular-nums"
                              [ngClass]="fiscalCodeLength === 16 ? '!text-primary' : '!text-slate-400'">
                            {{ fiscalCodeLength }}/16
                        </span>
                    </div>
                    <p class="!mb-0 !mt-1.5 !text-sm !text-red-600"
                       *ngIf="legalFiscalCode.invalid && (legalFiscalCode.dirty || legalFiscalCode.touched || submitted)">
                        <span *ngIf="legalFiscalCode.errors?.['required']">Il codice fiscale è obbligatorio.</span>
                        <span *ngIf="legalFiscalCode.errors?.['pattern'] || legalFiscalCode.errors?.['minlength']">
                            Inserisci un codice fiscale di 16 caratteri.
                        </span>
                    </p>
                </div>

                <div class="!min-w-0">
                    <label for="company-legal-document-number" class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">Numero documento</label>
                    <input type="text" class="form-control text-uppercase !min-h-11 !rounded-xl !border-slate-200 focus:!border-primary focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                           id="company-legal-document-number"
                           [(ngModel)]="company.legalDocumentNumber" name="legalDocumentNumber" required
                           #legalDocumentNumber="ngModel"
                           autocomplete="off"
                           (ngModelChange)="normalizeDocumentNumber()"
                           [class.is-invalid]="legalDocumentNumber.invalid && (legalDocumentNumber.dirty || legalDocumentNumber.touched || submitted)">
                    <p class="!mb-0 !mt-1.5 !text-xs !leading-snug !text-slate-400">
                        Numero della carta d'identità, come stampato sul documento.
                    </p>
                    <p class="!mb-0 !mt-1.5 !text-sm !text-red-600"
                       *ngIf="legalDocumentNumber.invalid && (legalDocumentNumber.dirty || legalDocumentNumber.touched || submitted)">
                        Il numero del documento è obbligatorio.
                    </p>
                </div>
            </div>
        </section>

        <section class="!rounded-2xl !border !border-border !bg-white !p-6 md:!p-8" aria-labelledby="id-docs-title">
            <div class="!mb-5 !border-b !border-slate-100 !pb-3">
                <h3 id="id-docs-title" class="!mb-1 !text-base !font-bold !text-strong">Carta d'identità</h3>
                <p class="!mb-0 !text-sm !leading-snug !text-subtle">
                    Carica fronte e retro. JPG, PNG o PDF, massimo 10 MB.
                </p>
            </div>

            <div class="!grid !grid-cols-1 !gap-5 md:!grid-cols-2">
                <div class="!min-w-0" *ngFor="let doc of identityDocuments">
                    <label class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">{{ doc.label }}</label>
                    <button type="button"
                            [ngClass]="dropzoneClasses(doc.field)"
                            [disabled]="isUploading(doc.field)"
                            (click)="fileInput.click()"
                            (dragover)="onDragOver($event, doc.field)"
                            (dragleave)="onDragLeave(doc.field)"
                            (drop)="onDocumentDrop($event, doc.field)">
                        <span *ngIf="isUploading(doc.field)" class="spinner-border spinner-border-sm !text-primary" role="status"></span>
                        <img *ngIf="!isUploading(doc.field) && getPreviewUrl(doc.field) && !isPdf(doc.field)"
                             [src]="getPreviewUrl(doc.field)" [alt]="doc.label"
                             class="!h-20 !w-28 !rounded-xl !border !border-slate-200 !object-cover !shadow-sm"/>
                        <i *ngIf="!isUploading(doc.field) && (!getPreviewUrl(doc.field) || isPdf(doc.field))"
                           class="bi !text-2xl"
                           [ngClass]="hasDocument(doc.field) ? (isPdf(doc.field) ? 'bi-file-earmark-pdf-fill !text-primary' : 'bi-check-circle-fill !text-primary') : 'bi-cloud-arrow-up !text-slate-400'"></i>
                        <span class="!text-sm !font-semibold !text-slate-700 !break-words" *ngIf="!hasDocument(doc.field) && !isUploading(doc.field)">
                            Trascina qui o clicca per caricare
                        </span>
                        <span class="!text-sm !font-semibold !text-slate-700 !break-all" *ngIf="hasDocument(doc.field) && !isUploading(doc.field)">
                            {{ getDocumentName(doc.field) }}
                        </span>
                        <span class="!text-sm !font-semibold !text-primary" *ngIf="isUploading(doc.field)">
                            Caricamento in corso...
                        </span>
                        <span class="!text-xs !text-slate-400">{{ doc.hint }}</span>
                    </button>
                    <input #fileInput type="file" class="d-none" accept=".pdf,.jpg,.jpeg,.png"
                           (change)="chooseDocument($event, doc.field)"/>
                    <p class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="getError(doc.field)">{{ getError(doc.field) }}</p>
                    <p class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="submitted && !hasDocument(doc.field) && !getError(doc.field)">
                        Questo documento è obbligatorio.
                    </p>
                </div>
            </div>
        </section>

        <section class="!rounded-2xl !border !border-border !bg-white !p-6 md:!p-8" aria-labelledby="cf-docs-title">
            <div class="!mb-5 !border-b !border-slate-100 !pb-3">
                <h3 id="cf-docs-title" class="!mb-1 !text-base !font-bold !text-strong">Tessera codice fiscale</h3>
                <p class="!mb-0 !text-sm !leading-snug !text-subtle">
                    Fronte e retro della tessera o del documento equivalente.
                </p>
            </div>

            <div class="!grid !grid-cols-1 !gap-5 md:!grid-cols-2">
                <div class="!min-w-0" *ngFor="let doc of fiscalDocuments">
                    <label class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">{{ doc.label }}</label>
                    <button type="button"
                            [ngClass]="dropzoneClasses(doc.field)"
                            [disabled]="isUploading(doc.field)"
                            (click)="fileInput.click()"
                            (dragover)="onDragOver($event, doc.field)"
                            (dragleave)="onDragLeave(doc.field)"
                            (drop)="onDocumentDrop($event, doc.field)">
                        <span *ngIf="isUploading(doc.field)" class="spinner-border spinner-border-sm !text-primary" role="status"></span>
                        <img *ngIf="!isUploading(doc.field) && getPreviewUrl(doc.field) && !isPdf(doc.field)"
                             [src]="getPreviewUrl(doc.field)" [alt]="doc.label"
                             class="!h-20 !w-28 !rounded-xl !border !border-slate-200 !object-cover !shadow-sm"/>
                        <i *ngIf="!isUploading(doc.field) && (!getPreviewUrl(doc.field) || isPdf(doc.field))"
                           class="bi !text-2xl"
                           [ngClass]="hasDocument(doc.field) ? (isPdf(doc.field) ? 'bi-file-earmark-pdf-fill !text-primary' : 'bi-check-circle-fill !text-primary') : 'bi-cloud-arrow-up !text-slate-400'"></i>
                        <span class="!text-sm !font-semibold !text-slate-700 !break-words" *ngIf="!hasDocument(doc.field) && !isUploading(doc.field)">
                            Trascina qui o clicca per caricare
                        </span>
                        <span class="!text-sm !font-semibold !text-slate-700 !break-all" *ngIf="hasDocument(doc.field) && !isUploading(doc.field)">
                            {{ getDocumentName(doc.field) }}
                        </span>
                        <span class="!text-sm !font-semibold !text-primary" *ngIf="isUploading(doc.field)">
                            Caricamento in corso...
                        </span>
                        <span class="!text-xs !text-slate-400">{{ doc.hint }}</span>
                    </button>
                    <input #fileInput type="file" class="d-none" accept=".pdf,.jpg,.jpeg,.png"
                           (change)="chooseDocument($event, doc.field)"/>
                    <p class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="getError(doc.field)">{{ getError(doc.field) }}</p>
                    <p class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="submitted && !hasDocument(doc.field) && !getError(doc.field)">
                        Questo documento è obbligatorio.
                    </p>
                </div>
            </div>
        </section>

        <div class="step-actions">
            <div class="step-actions-end">
                <p class="!mb-0 !w-full !text-right !text-sm !text-red-700"
                   *ngIf="submitted && (legalDataStep1.invalid || !allDocumentsUploaded || hasPendingUploads)">
                    Completa i campi evidenziati e carica tutti i documenti per continuare.
                </p>
                <button class="btn-procedi" type="submit" [disabled]="isProcessing || hasPendingUploads">
                    <span *ngIf="isProcessing" class="spinner-border spinner-border-sm me-2" role="status"></span>
                    {{ isProcessing ? 'Caricamento...' : 'Procedi' }}
                </button>
            </div>
        </div>
    </form>
</div>
